<template>
  <div class="flex items-center justify-center min-h-screen px-4 py-4">
    <ProjectsGrid />
  </div>
</template>
<script lang="ts" setup>
const i18n = useI18n();
useSeoMeta({
  title: i18n.t("menuKeys.projects"),
  description:
    "Highfield Music Studio provides classes for instruments, DJing, music production, monthly packs, and group lessons.",
  keywords:
    "studio, music, instruments, recording, audio equipment, midi, dj gear, microphones, studio equipment",
  ogTitle: "Projects | Highfield Music Studio",
  ogDescription:
    "Highfield Music Studio provides classes for instruments, DJing, music production, monthly packs, and group lessons.",
  ogImage: "/images/logos/studio/1.jpg",
  twitterCard: "summary_large_image",
  twitterTitle: "Projects | Highfield Music Studio",
  twitterDescription:
    "Highfield Music Studio provides classes for instruments, DJing, music production, monthly packs, and group lessons.",
  twitterImage: "/images/media/studio/1.jpg",
});
</script>
